import Api from '@/services/Api'

// Automatsko knjizenje racuna prema prijasnjim knjizenjima istog partnera.
export default {

  // Prijedlog za jedan dokument: {CompanyId, MainLedgerId}
  prijedlog (query) {
    return Api().get('knjizenje/prijedlog', {params: query})
  },

  // Racuni bez knjizenja, svaki s prijedlogom: {CompanyId, BusinessYear, MLType}
  neproknjizeni (query) {
    return Api().get('knjizenje/neproknjizeni', {params: query})
  },

  // {CompanyId, ids: [], samoSigurne, UserId, email, First, Last}
  proknjizi (podaci) {
    return Api().post('knjizenje/proknjizi', podaci)
  }
}
